import { useState } from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
} from '@mui/material';
import { TARGET_LANGUAGES } from '../types/translation.types';

interface TranslationFormProps {
  onSubmit: (urls: string, targetLang: string) => void;
  isLoading: boolean;
}

export default function TranslationForm({ onSubmit, isLoading }: TranslationFormProps) {
  const [urls, setUrls] = useState('');
  const [targetLang, setTargetLang] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!urls.trim() || !targetLang) return;
    onSubmit(urls, targetLang);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          URLs a traducir (una por línea):
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={6}
          value={urls}
          onChange={(e) => setUrls(e.target.value)}
          placeholder="https://front.indexado.production.alquimio.cloud/spec?modelId=xxx&lang=esCL&version=V5"
          required
        />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          Ingresa las URLs separadas por líneas. Cada URL debe contener los parámetros: modelId, lang y version.
        </Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <FormControl fullWidth>
          <InputLabel>Idioma de destino</InputLabel>
          <Select
            value={targetLang}
            label="Idioma de destino"
            onChange={(e) => setTargetLang(e.target.value)}
            required
          >
            {TARGET_LANGUAGES.map((lang) => (
              <MenuItem key={lang.value} value={lang.value}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Button
        type="submit"
        variant="contained"
        size="large"
        disabled={isLoading || !urls.trim() || !targetLang}
      >
        {isLoading ? 'Verificando URLs...' : 'Iniciar Traducción'}
      </Button>
    </form>
  );
}
